export enum Dimensions {
    Height = 496,
    Width = 420,
    Top = 128,
    Bottom = 250,
}
